module.exports = __webpack_public_path__ + "img/02.54b24890.png";